export default __webpack_public_path__ + "static/Picture1-266f0e841312b342f0dd9bf5c4253d76.webp";